import React from 'react';
import ToastContainer from './ToastContainer';
import LoadingScreen from './LoadingScreen';

export default function PageLayout({ 
  children, 
  loading = false, 
  toasts = [], 
  onCloseToast = () => {} 
}) {
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <div className="loading-spinner w-8 h-8 mx-auto mb-4"></div>
              <p className="text-gray-600">Loading...</p>
            </div>
          </div>
        </div>
        <ToastContainer toasts={toasts} onCloseToast={onCloseToast} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {children}
      <ToastContainer toasts={toasts} onCloseToast={onCloseToast} />
    </div>
  );
} 